import { generateRandomFirstName } from '../generateRandomFirstName';
import { generateRandomLastName } from '../generateRandomLastName';

export function generateRandomLogin(): string {
    return `${generateRandomFirstName().toLowerCase()}.${generateRandomLastName().toLowerCase()}`;
}
